import React from 'react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { motion } from 'framer-motion';
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  className,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-holistic-wine';
  const variants = {
    primary: 'bg-holistic-wine hover:bg-holistic-wine-dark text-white shadow-md hover:shadow-lg',
    secondary: 'bg-holistic-gold hover:bg-[#b38f2e] text-white shadow-md hover:shadow-lg',
    outline: 'border-2 border-holistic-wine text-holistic-wine hover:bg-holistic-wine hover:text-white'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg md:text-xl font-semibold'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={cn(baseStyles, variants[variant], sizes[size], className)} {...props} data-id="element-184">
      {children}
    </motion.button>;
}